<span class="category-debug {{ template }}">{{ info }}</span>
